// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__32zhT","icon":"footer_icon__3DgtI","icon_heart":"footer_icon_heart__KHL76"};